import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import "./UserDialog.css";
import { validateField, isNullOrEmpty } from "./Util";

export class UserDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			UserData: {},
			open: false,
			Buildings: [],
			filter: "",
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
		this.deleteUser = this.deleteUser.bind(this);
		this.getBuildings();
		this.resendEmail = this.resendEmail.bind(this);
	}

	async getBuildings() {
		if (this.state.Buildings.length === 0) {
			var dt = await fetch("Building");
			dt = await dt.json();
			dt = dt.sort((a, b) => {
				return a.building_name.localeCompare(b.building_name);
			});
			this.setState({ Buildings: dt });
		}
	}

	componentDidUpdate(prevProps) {
		if ((this.props.UsersID !== prevProps.UsersID && this.props.visible) || (this.props.visible !== prevProps.visible && this.props.visible)) {
			if (this.props.UsersID) this.getData();
			else this.setState({ open: true, UserData: {} });
		}
	}

	async getData() {
		var data = await fetch("User/GetUserInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ usersId: this.props.UsersID }),
		});
		data = await data.json();
		this.setState({ open: true, UserData: data });
	}
	dynamicOnChange = (event) => {
		var columnName = null;
		if (event.target.nodeName === "INPUT" || event.target.nodeName === "TEXTAREA") {
			columnName = event.target.attributes.columnname.value;
		} else if (event.currentTarget.nodeName === "LI") {
			columnName = event.currentTarget.dataset.columnname;
		}

		var data = this.state.UserData;
		data[columnName] = event.target.value;
		if (event.target.type === "checkbox") {
			data[columnName] = event.target.checked;
		}

		this.setState({ UserData: data });
	};

	async resendEmail() {
		if (!window.confirm("Are you sure you want to resend?")) return;
		await fetch("User/SendPasswordReset", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.state.UserData.email_address),
		});
	}
	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	updateBuildings = (event) => {
		var buildingsId = event.currentTarget.value;
		var included = event.currentTarget.checked;
		var currentBuildings = this.getBuildingsArray();

		if (included) {
			currentBuildings.push(buildingsId);
		} else if (currentBuildings.indexOf(buildingsId) > -1) {
			currentBuildings.splice(currentBuildings.indexOf(buildingsId), 1);
		}

		var userData = this.state.UserData;
		userData.buildings = currentBuildings.join(", ");
		this.setState({ UserData: userData });
	};

	getBuildingsArray() {
		return this.state.UserData.buildings ? this.state.UserData.buildings.split(",").map((item) => item.toString().toLowerCase().trim()) : [];
	}

	async saveData() {
		var data = this.state.UserData;
		data.title = data.title || "";

		if (!validateField(data, "email_address", "Email Address") || !validateField(data, "first_name", "First Name") || !validateField(data, "last_name", "Last Name")) {
			return;
		}

		var dt = await fetch("User/SaveUserInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(JSON.stringify(data)),
		});
		if (!dt.ok) {
			alert("An error occurred while saving.");
			return;
		}

		var res = await dt.text();
		if (!isNullOrEmpty(res)) {
			alert(res);
			return;
		}

		this.setState({ open: false });
		this.props.OnClose();
	}

	async deleteUser() {
		if (!window.confirm("Are you sure you want to delete this user?")) return;
		var dt = await fetch("User/DeleteUser", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.props.UsersID),
		});

		dt = await dt.text();

		if (!isNullOrEmpty(dt)) {
			alert(dt);
		}
		this.onClose();
	}

	render() {
		var baseData = this.state.UserData;
		var inputProps = { readOnly: false };
		var labelProps = { shrink: true };
		var userBuildings = this.getBuildingsArray();
		return (
			<Dialog open={this.state.open} onClose={this.onClose} maxWidth="md">
				<DialogTitle>{baseData.users_id ? "Edit User" : "New User"}</DialogTitle>
				<DialogContent>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "first_name" }} label="First Name" value={baseData.first_name} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "last_name" }} label="Last Name" value={baseData.last_name} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "email_address" }} label="Email" value={baseData.email_address} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" className="contact-control" onChange={this.dynamicOnChange} inputProps={{ columnName: "title" }} label="Title" value={baseData.title} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<FormControl variant="outlined" style={{ width: "calc(25% - 10px)", marginTop: "12px" }}>
						<InputLabel id="type-label-id">Ticketing Role</InputLabel>
						<Select labelWidth={100} inputProps={{ columnname: "role" }} value={baseData.role} onChange={this.dynamicOnChange} labelId="type-label-id">
							<MenuItem data-columnname="role" value="Client">
								Client
							</MenuItem>
							<MenuItem data-columnname="role" value="Admin">
								Admin
							</MenuItem>
							<MenuItem data-columnname="role" value="Ticketing">
								Ticketing
							</MenuItem>
						</Select>
					</FormControl>
					<div>
						<TextField
							label="Filter Buildings"
							onChange={(event) => {
								this.setState({ filter: event.target.value });
							}}></TextField>
						{this.state.Buildings.filter((bldg) => {
							return isNullOrEmpty(this.state.filter) || bldg.building_name.toString().toLowerCase().includes(this.state.filter.toLowerCase());
						}).map((building) => {
							return <FormControlLabel key={building.buildings_id} style={{ display: "block" }} label={building.building_name} control={<Checkbox value={building.buildings_id} onChange={(event) => this.updateBuildings(event)} checked={userBuildings.includes(building.buildings_id)}></Checkbox>}></FormControlLabel>;
						})}
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
					<Button onClick={this.deleteUser} hidden={isNullOrEmpty(this.props.UsersID)} color="primary">
						Delete
					</Button>
					{!this.state.UserData.has_accepted_invite && (
						<Button onClick={this.resendEmail} hidden={isNullOrEmpty(this.props.UsersID)} color="primary">
							Resend Email
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}
